import React from 'react'
import { useApp } from '../../context/AppContext'
import { Icon } from '../../shared'
import { Card, Btn } from '../../shared/components'
import { listUpcomingSessions } from '../../api/sessions.api'
import { locale } from '../../shared/format'

const MAX_ROWS = 5

// Sesi terdekat lintas program. Endpoint-nya per program, jadi satu panggilan
// per program lalu digabung dan diurutkan di sini; jumlah program per lembaga
// kecil, dan satu program yang gagal dimuat tidak boleh mengosongkan kartunya.
export function UpcomingSessionsCard({ programs }) {
  const { lang, navigate } = useApp()
  const [sessions, setSessions] = React.useState(null) // null = memuat

  const programKey = programs.map((p) => p.id).join(',')
  React.useEffect(() => {
    if (!programs.length) { setSessions([]); return }
    let batal = false
    Promise.all(
      programs.map((p) =>
        listUpcomingSessions(p.id)
          .then((rows) => rows.map((s) => ({ ...s, programName: p.name })))
          .catch(() => [])
      )
    ).then((lists) => {
      if (batal) return
      const semua = lists.flat().sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at))
      setSessions(semua.slice(0, MAX_ROWS))
    })
    return () => { batal = true }
  }, [programKey]) // eslint-disable-line react-hooks/exhaustive-deps

  const loc = locale(lang)
  const title = lang === 'id' ? 'Sesi Mendatang' : 'Upcoming Sessions'

  return (
    <Card
      title={title}
      action={
        <Btn variant="ghost" size="sm" onClick={() => navigate('training')}>
          {lang === 'id' ? 'Lihat semua' : 'View all'}
        </Btn>
      }
      noPad
    >
      {sessions == null ? (
        <div className="tiny muted" style={{ padding: 18 }}>{lang === 'id' ? 'Memuat…' : 'Loading…'}</div>
      ) : sessions.length === 0 ? (
        <div className="col" style={{ alignItems: 'center', padding: '28px 18px', gap: 8 }}>
          <Icon name="calendar" size={22} color="var(--text-4)" />
          <div className="tiny muted">{lang === 'id' ? 'Belum ada sesi terjadwal' : 'No sessions scheduled'}</div>
          <Btn variant="secondary" size="sm" onClick={() => navigate('training')}>
            {lang === 'id' ? 'Jadwalkan sesi' : 'Schedule a session'}
          </Btn>
        </div>
      ) : (
        <div className="col" style={{ padding: '4px 18px 10px' }}>
          {sessions.map((s) => {
            const d = new Date(s.scheduled_at)
            return (
              <div
                key={s.id}
                className="row gap-3"
                style={{ alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                <div style={{ width: 44, textAlign: 'center', flexShrink: 0 }}>
                  <div className="tiny muted" style={{ textTransform: 'uppercase' }}>
                    {d.toLocaleDateString(loc, { month: 'short' })}
                  </div>
                  <div style={{ fontSize: 18, fontWeight: 600, lineHeight: 1.1 }}>{d.getDate()}</div>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="small text-truncate" style={{ fontWeight: 500 }}>{s.title}</div>
                  <div className="tiny muted text-truncate">
                    {d.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' })}
                    {s.programName ? ` · ${s.programName}` : ''}
                    {s.location ? ` · ${s.location}` : ''}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </Card>
  )
}
